import React, { useState, useContext } from "react";
import { useNavigate } from "react-router";
import { Avatar, Divider, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { auth } from "../../firebase";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { STORAGE_BUCKET } from "../../common/constants";
import { UserContext } from "../../context/UserContext";
import { getDataFromLocalStorage, logOffPosStaff } from "../util";
import bkstApi from "../../api";

const menuId = "user-menu";
export default function UserLoggedInButton(props) {
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const finishSignOut = () => {
    auth
      .signOut()
      .then(() => {
        setUser("");
        localStorage.removeItem("pos");
        localStorage.removeItem("kds");
        navigate("/");
      })
      .catch(() => {});
  };

  const logout = () => {
    setAnchorEl(null);

    if (logOffPosStaff(navigate)) {
      return;
    } else if (getDataFromLocalStorage("kds") && getDataFromLocalStorage("kds-user")) {
      localStorage.removeItem("kds-user");
      navigate("/access-code");
    } else if (user?.impersonating) {
      bkstApi
        .post("/my/end-impersonation")
        .catch((err) => {
          console.log("end-impersonation failed", err);
        })
        .finally(finishSignOut);
    } else {
      finishSignOut();
    }
  };

  const displayName = [user?.firstName, user?.lastName].filter(Boolean).join(" ");
  const displayRole = user?.role
    ? user.role
        .split(" ")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ")
    : "";
  const showIdentity = Boolean(displayName || displayRole);

  return (
    <span>
      <Avatar
        src={`${STORAGE_BUCKET}/img/u/${user.uid}.webp`}
        onClick={handleProfileMenuOpen}
        style={{ cursor: "pointer" }}
      />
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        {showIdentity && (
          <MenuItem
            disabled
            sx={{
              gap: 2,
              py: 2,
              backgroundColor: "action.hover",
              opacity: "1 !important",
              "&.Mui-disabled": { opacity: 1 },
            }}
          >
            <Avatar
              src={`${STORAGE_BUCKET}/img/u/${user.uid}.webp`}
              sx={{ width: 48, height: 48 }}
            />
            <ListItemText
              primary={displayName || "Staff"}
              secondary={displayRole}
              primaryTypographyProps={{ variant: "subtitle1", fontWeight: 700 }}
              secondaryTypographyProps={{ variant: "body2" }}
            />
          </MenuItem>
        )}
        {showIdentity && <Divider />}
        <MenuItem onClick={logout}>
          <ListItemIcon>
            <ExitToAppIcon />
          </ListItemIcon>
          <ListItemText primary={user?.impersonating ? "End impersonation" : "Logout"} />
        </MenuItem>
      </Menu>
    </span>
  );
}
